import React, {memo, Suspense} from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/header"
import connect from "./connect"

export type SnailItemActiveIndicatorProps = {
    isActive: boolean
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
}

export const SnailItemActiveIndicator = memo(({isActive, templating}: SnailItemActiveIndicatorProps) => {
    const ActiveIndicator = useTemplatedComponent(templating, MANIFEST)
    return (
        <Suspense>
            <ActiveIndicator isActive={isActive} />
        </Suspense>
    )
})
SnailItemActiveIndicator.displayName = "SnailItemActiveIndicator"

export default connect(SnailItemActiveIndicator)
